import { combineReducers } from 'redux';

import vivaLeite from './vivaLeite/combineReducers';

export default combineReducers({
	vivaLeite,
});
